import { render, staticRenderFns } from "./VendorOrderList.vue?vue&type=template&id=3eff6dd1&scoped=true&"
import script from "./VendorOrderList.vue?vue&type=script&lang=js&"
export * from "./VendorOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eff6dd1",
  null
  
)

export default component.exports